<template>
    <svg viewBox="0 0 22 22.0022" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M22 21.9985C21.9377 18.7795 20.8083 16.1323 18.612 14.0535C16.4817 12.0407 13.948 11.0214 11.011 11.0031C4.92433 10.9591 0.00366667 15.938 0 22.0022H22V21.9985Z"
            fill="#30A29D" />
        <path
            d="M0 5.85606e-05C0.0623333 3.21912 1.19167 5.86624 3.388 7.94506C5.51834 9.9579 8.052 10.9771 10.989 10.9955C17.0757 11.0431 21.9963 6.06422 22 5.85606e-05H0Z"
            fill="#81DADA" />
    </svg>
</template>
